<template>
    <div class="page-wrapper index-page">
        <Header/>
        <div class="wrapper">
            <div class="first-screen">
                <div class="eclipse eclipseFadeInLeft">
                    <div class="vcenter-container">
                        <div class="vcenter"><img src="@/image/eclipse.png"></div>
                    </div>
                </div>
                <div class="container">
                    <div class="content-block">
                        <div class="vcenter-container">
                            <div class="vcenter">
                                <div class="title">
                                    <h1 class="keyword">Астропроцессор Maya</h1>
                                </div>
                                <div class="text">
                                    Программа, которая строит карты рождения, помогает понять себя и близких, а также прогнозирует события
                                </div>
                                <natal-input :dark-mode="true"/>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="first-screen-bg bg-animation"></div>
            </div>
        </div>
        <Footer :no-footer="true"/>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import NatalInput from '@/components/NatalInput'

    export default {
        name: "Index",

        components: {
            Header, Footer, NatalInput
        },


    }
</script>